import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-turn',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './turn.component.html',
  styleUrl: './turn.component.css'
})
export class TurnComponent {

}
